import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getAllOrganizations } from '../../../api/organization';
import { IGetOrganization } from '../../../ts/interface/organization';

const useOrganizations = (
  parameters?: IGetOrganization,
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: ['useOrganizations', parameters?.organization_id],
    queryFn: () => getAllOrganizations(parameters),
    ...options,
  });
};

export default useOrganizations;
